import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createGraduadosProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "graduados",
        label: "Graduados",
        subLabel: "Gestión de graduados",
        action: ctx.navigateModule("alumnos/graduados"),
        search: (): ISearchResult[] => ([])
    };
};